import React from "react";

export const PreviewUrlHandler: React.FC = () => {
    return null;
};
